import { ROUTES } from "~/router";
import { LOGIN_STEPS } from "~/screens/Auth/Login/constants";
import { useRedirect, validateError } from "~/shared";
import { useAuthStore } from "~/stores";

export const EMAIL_ERROR_STATUS = {
  user_already_registered: 400,
  invalid_email: 422,
};

interface UseExistingEmailRedirectionProps {
  error: unknown;
  routeToRedirect?: string;
  email?: string;
}

export const useExistingEmailRedirection = ({
  error,
  routeToRedirect,
  email,
}: UseExistingEmailRedirectionProps) => {
  const redirect = useRedirect();
  const errorStatus = validateError(error)?.response?.data?.status;
  const setAuthEmail = useAuthStore((state) => state.setAuthEmail);
  const setLoginStep = useAuthStore((state) => state.setLoginStep);

  const isInvalidEmail = errorStatus === EMAIL_ERROR_STATUS.invalid_email;
  const isAlreadyRegisteredEmail =
    errorStatus === EMAIL_ERROR_STATUS.user_already_registered;

  const handleExistingEmailRedirection = () => {
    if (isAlreadyRegisteredEmail) {
      setAuthEmail(email ?? "");
      setLoginStep(LOGIN_STEPS.PASSWORD);
      const redirectUrl = routeToRedirect
        ? `${ROUTES.fullLogin}?source=qualifier-questions&redirect=${routeToRedirect}&email=${email}&keepBookingFlow=true`
        : `${ROUTES.fullLogin}?source=qualifier-questions&email=${email}&keepBookingFlow=true`;
      redirect(redirectUrl);
    }
  };

  return {
    handleExistingEmailRedirection,
    isInvalidEmail,
    isAlreadyRegisteredEmail,
  };
};
